import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  text-align: center;
  padding: 8px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  overflow: auto;
`;

export const ApplicationSelected = styled.div`
  padding: 8px 10px;
  transition: 0.2s;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.shapes.borderRadius};

  .selected-app-title {
    display: flex;
    align-items: center;

    svg {
      height: 20px;
      margin-right: 4px;

      path {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }

    h1 {
      color: ${({ theme }) => theme.colors.text};
      font-size: ${({ theme }) => theme.fontSizes.extraLarge};
    }
  }

  .selected-app-icon {
    margin-left: 10px;
    display: flex;
    flex-direction: column;

    .anticon svg {
      transition: 0.2s;
      height: 8px;
      margin: 2px 0;
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  &:hover {
    background: ${({ theme }) => theme.colors.background1};

    .selected-app-icon .anticon svg {
      height: 10px;
    }
  }
`;
